import React, { useMemo } from "react";
import AutoFillComponent from "../../../AutoFillComponent";
import { LongButton, SelectForm } from "../../../Buttons";
import { Divs, UlElements } from "../../../StyledComponents";
import TextInputModal from "../../../TextInputModal";
import { orderTypeMount } from "../../../../../helpers/OrdersFunctionsGlobal";
import { useDispatch, useSelector } from "react-redux";
import { getParcelTerminal } from "../../../../../redux/Actions/parcelTerminalAction";
import { sanitizePersonName } from "../../../../../helpers/Utils";

const sanitizeNumeric = (value) => String(value || "").replace(/[\s.]/g, "");
const sanitizePhone = (value) => String(value || "").replace(/[^0-9+]/g, "");

function RenderAddress({
  carriers,
  onChange,
  shippingAddress,
  billingAddress,
  errors,
  general,
  countries,
}) {
  const dispatch = useDispatch();
  const { parcel_terminals } = useSelector((state) => state.options);

  const parcelTerminalName = useMemo(() => {
    console.log("parcelTerminalName");
    if (!shippingAddress?.parcel_terminal_id) return null;
    return dispatch(getParcelTerminal(shippingAddress?.parcel_terminal_id))
      ?.label;
  }, [shippingAddress?.parcel_terminal_id, parcel_terminals]);

  const carrierType = useMemo(() => {
    const c_carrier = carriers.find((e) => e.id == general.carrier_id);
    if (!c_carrier) return null;
    const { order_type, delivery } = orderTypeMount(
      c_carrier,
      shippingAddress.parcel_terminal_id
    );
    console.log({ order_type, delivery });
    if (order_type == "at_the_store") return "store";
    if (delivery.includes("_postMachine")) return "Post machine";
    if (delivery.includes("_home")) return "Home delivery";
    if (delivery.includes("dpd_b2c")) return "Home delivery";
    return "";
  }, [general.carrier_id, carriers]);

  const onChangeNumeric = (e) => {
    onChange({
      ...e,
      target: {
        ...e.target,
        name: e.target.name,
        value: sanitizeNumeric(e.target.value),
      },
    });
  };

  const onChangePhone = (e) => {
    onChange({
      ...e,
      target: {
        ...e.target,
        name: e.target.name,
        value: sanitizePhone(e.target.value),
      },
    });
  };

  const onChangeName = (e) => {
    onChange({
      ...e,
      target: {
        ...e.target,
        name: e.target.name,
        value: sanitizePersonName(e.target.value),
      },
    });
  };

  const autoFillChange = (full_vall, type, updateNext) => {
    onChange(full_vall, type, updateNext);
  };

  const ArrayBuilder = (arr) => {
    const responseBuild = arr.map((e) => ({
      label: `${e.firstname} ${e.lastname} ${e.street}`,
      value: e.id,
      city: e.city,
      company: e.company,
      company_code: e.company_code,
      firstname: e.firstname,
      lastname: e.lastname,
      other: e.other,
      phone: e.phone,
      postal_code: e.postal_code,
      street: e.street,
      vat_code: e.vat_code,
    }));
    return responseBuild;
  };

  const renderSearchEndPoint = (value) => {
    const arrayOfString = value.trim().split(" ");
    const searchString = arrayOfString.reduce(
      (cur, acc) =>
        cur + `&q[firstname_or_lastname_or_street_or_other_i_cont_any]=${acc}`,
      ""
    );
    return `/api/v1/addresses?${searchString}`;
  };

  return (
    <div className="col-12 bg-silver row py-3 m-0">
      <Divs className="col-6" style={{ width: "50%" }}>
        <div className="d-flex justify-content-between font-weight-bold mb-3">
          <span>Payer's address</span>
        </div>
        <UlElements>
          <li>
            <AutoFillComponent
              endPoint={renderSearchEndPoint}
              onChange={(_, full) =>
                autoFillChange(
                  full,
                  "billingAddress",
                  carrierType === "Home delivery"
                )
              }
              arrayBuilder={ArrayBuilder}
            />
          </li>
          <li>
            <TextInputModal
              text="First name"
              placeholder="Enter"
              name="[billingAddress]firstname"
              value={billingAddress.firstname}
              onChange={onChangeName}
              error={errors["billing_address.firstname"]}
            />
          </li>
          <li>
            <TextInputModal
              text="Last name"
              placeholder="Enter"
              name="[billingAddress]lastname"
              value={billingAddress.lastname}
              onChange={onChangeName}
              error={errors["billing_address.lastname"]}
            />
          </li>
          <li>
            <SelectForm
              placeholder="Country"
              onlyPlaceholder="Choose"
              value={billingAddress.country_id}
              onChange={(value) =>
                onChange({
                  target: { name: "[billingAddress]country_id", value },
                })
              }
              options={countries?.map((e) => ({
                value: e.id,
                label: e.en_name,
              }))}
              error={errors["billing_address.country_id"]}
            />
          </li>
          <li>
            <TextInputModal
              text="Address"
              placeholder="Enter"
              name="[billingAddress]street"
              value={billingAddress.street}
              onChange={onChange}
              error={errors["billing_address.street"]}
            />{" "}
          </li>
          <li>
            <TextInputModal
              text="City"
              placeholder="Enter"
              name="[billingAddress]city"
              value={billingAddress.city}
              onChange={onChange}
              error={errors["billing_address.city"]}
            />{" "}
          </li>
          <li>
            <TextInputModal
              text="Postal code"
              placeholder="Enter"
              name="[billingAddress]postal_code"
              value={billingAddress.postal_code}
              onChange={onChangeNumeric}
              error={errors["billing_address.postal_code"]}
            />
          </li>
          <li>
            <TextInputModal
              text="Phone"
              require={true}
              placeholder="Enter"
              name="[billingAddress]phone"
              value={billingAddress.phone}
              onChange={onChangePhone}
              error={errors["billing_address.phone"] || errors.billing_phone}
            />{" "}
          </li>
          <li>
            <TextInputModal
              type="email"
              text="Email"
              placeholder="Enter"
              name="[billingAddress]other"
              value={billingAddress.other}
              onChange={onChange}
              error={errors["billing_address.email"]}
            />
          </li>
          <li>
            <TextInputModal
              text="Company"
              placeholder="Enter"
              name="[billingAddress]company"
              value={billingAddress.company}
              onChange={onChange}
            />
          </li>
          <li>
            <TextInputModal
              required={!!billingAddress.company}
              text="Company code"
              placeholder="Enter"
              name="[billingAddress]company_code"
              value={billingAddress.company_code}
              onChange={onChangeNumeric}
              error={errors["billing_address.company_code"]}
            />
          </li>

          <li>
            <TextInputModal
              text="VAT code"
              placeholder="Enter"
              name="[billingAddress]vat_code"
              value={billingAddress.vat_code}
              onChange={onChangeNumeric}
            />
          </li>
        </UlElements>
      </Divs>
      <Divs
        className="col-6"
        style={{
          width: "50%",
          borderLeft: "1px solid #e3e3e3",
        }}
      >
        <div className="d-flex justify-content-between font-weight-bold mb-3">
          <span>Delivery address {carrierType && `(${carrierType})`}</span>
        </div>

        <UlElements>
          {["", "Home delivery"].includes(carrierType) && (
            <li>
              <AutoFillComponent
                endPoint={renderSearchEndPoint}
                onChange={(_, full) => autoFillChange(full, "shippingAddress")}
                arrayBuilder={ArrayBuilder}
              />
            </li>
          )}
          {carrierType !== "Store" && (
            <>
              <li>
                <TextInputModal
                  text="First name"
                  placeholder="Enter"
                  name="[shippingAddress]firstname"
                  value={shippingAddress.firstname}
                  onChange={onChangeName}
                  error={errors["shippingAddress.firstname"]}
                />
              </li>
              <li>
                <TextInputModal
                  text="Last name"
                  placeholder="Enter"
                  name="[shippingAddress]lastname"
                  value={shippingAddress.lastname}
                  onChange={onChangeName}
                  error={errors["shippingAddress.lastname"]}
                />
              </li>
            </>
          )}
          <li>
            <SelectForm
              placeholder="Country"
              onlyPlaceholder="Choose"
              value={shippingAddress.country_id}
              onChange={(value) =>
                onChange({
                  target: { name: "[shippingAddress]country_id", value },
                })
              }
              options={countries?.map((e) => ({
                value: e.id,
                label: e.en_name,
              }))}
              error={errors["shipping_address.country_id"]}
            />
          </li>
          {carrierType !== "Post machine" ? (
            <>
              <li>
                <TextInputModal
                  text="Address"
                  placeholder="Enter"
                  name="[shippingAddress]street"
                  value={shippingAddress.street}
                  onChange={onChange}
                  error={errors["shippingAddress.street"]}
                />{" "}
              </li>
              <li>
                <TextInputModal
                  text="City"
                  placeholder="Enter"
                  name="[shippingAddress]city"
                  value={shippingAddress.city}
                  // disabled={haveRivileShops}
                  onChange={onChange}
                  error={errors["shippingAddress.city"]}
                />{" "}
              </li>
              <li>
                <TextInputModal
                  text="Postal code"
                  placeholder="Enter"
                  name="[shippingAddress]postal_code"
                  value={shippingAddress.postal_code}
                  required={true}
                  // disabled={haveRivileShops}
                  onChange={onChangeNumeric}
                  error={errors["shippingAddress.postal_code"]}
                />
              </li>
            </>
          ) : (
            <li>
              <TextInputModal
                text="Parcel"
                value={parcelTerminalName}
                disabled={true}
              />
            </li>
          )}
          <li>
            <TextInputModal
              require={true}
              text="Phone"
              placeholder="Enter"
              name="[shippingAddress]phone"
              value={shippingAddress.phone}
              onChange={onChangePhone}
              error={errors["shipping_address.phone"] || errors.shipping_phone}
            />
          </li>
          <li>
            <TextInputModal
              text="Email"
              placeholder="Enter"
              name="[shippingAddress]other"
              value={shippingAddress.other}
              onChange={onChange}
              error={errors["shippingAddress.email"]}
            />
          </li>
          {general.rline && (
            <li>
              <span className="text-bold my-1">
                <span className="text-danger">[R-Line]:</span>{" "}
                {general.rline_code}
              </span>
            </li>
          )}
          {general.consultant && (
            <>
              <li>
                <span className="text-bold my-1">
                  <span className="text-danger">Consultant code:</span>{" "}
                  {general.consultant_code}
                </span>
              </li>
              <LongButton
                text={general.consultant_email}
                style={{
                  backgroundColor: "silver",
                  color: "black",
                  fontSize: "0.8rem",
                  height: "24px",
                }}
              />
            </>
          )}
        </UlElements>
      </Divs>
    </div>
  );
}

export default RenderAddress;
